export function isActive(team) {
  return !team.archived_at;
}

export function isArchived(team) {
  return team.archived_at !== null;
}
